import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import { useTranslation } from "react-i18next";
import * as URLS from "../../../../urls";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { getMyCartService } from "redux/services/general_service";

const LoginForm = ({ onSubmit, isLoading }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(); // إضافة i18n

  const [formData, setFormData] = useState({
    account: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    const newErrors = {};
    if (!formData.password) {
      newErrors.password = t("passwordRequired");
    } else if (formData.password.length < 6) {
      newErrors.password = t("passwordTooShort");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.account !== "" && formData.password !== "") {
      setLoading(true); // Start loading
      const token = null;
      axios
        .post(`${URLS.baseUrl}/${URLS?.loginURL}`, formData)
        .then((response) => {
          if (response?.status === 200) {
            //   token = response?.data?.data?.token;
            localStorage.setItem("Token", response?.data?.data?.token);
            localStorage.setItem(
              "permissions",
              JSON.stringify(response?.data?.data?.user?.permissions)
            );
            localStorage.setItem("isAuthenticated", "true");
            localStorage.setItem(
              "user",
              JSON.stringify({
                id: response.data.data?.user?.id,
                first_name: response.data.data?.user?.first_name,
                last_name: response.data.data?.user?.last_name,
                email: response.data.data?.user?.email,
                phone: response.data.data?.user?.phone,
                address: response.data.data?.user?.address,
                province: response.data.data?.user?.province,
              })
            );
            //
            const localCart = JSON.parse(
              localStorage.getItem("cartItems") || "[]"
            );
            if (localCart.length > 0) {
              try {
                for (const item of localCart) {
                  console.log(item);
                  axios.post(
                    `${URLS.baseUrl}/${URLS?.cartURL}`,
                    {
                      product_id: item.id,
                      quantity: item.quantity,
                      product_variant_id: item.selectedVariant?.id,
                    },
                    {
                      headers: {
                        Accept: "*/*",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${response?.data?.data?.token}`, // Replace with your actual token
                      },
                    }
                  );
                }
                // مسح السلة المحلية بعد الدمج
                localStorage.removeItem("cartItems");
                localStorage.removeItem("cartCount");
              } catch (error) {
                console.error("Error merging carts:", error);
              }
            }
            navigate("/");
          } else {
            response?.payload?.errors?.map((error) => toast.warn(error));
          }
        })
        .catch((error) => {
            const errors = error?.response?.data?.errors;
      if (errors && typeof errors === "object") {
       
        const allErrors = Object.values(errors).flat();
        allErrors.forEach((msg) => toast.warn(msg));
      } else {
        toast.error(t("generalError"));
      }
        })
        .finally(() => {
         /* navigate("/");
          window.location.reload();*/
          setTimeout(() => {
            dispatch(getMyCartService());
          }, 300);

          setLoading(false);
        });
    } else {
      setError(t.invalidCredentials);
    }
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`space-y-6 ${
        i18n.language === "ar" ? "text-right" : "text-left"
      }`} // تغيير المحاذاة بناءً على اللغة
      dir={i18n.language === "ar" ? "rtl" : "ltr"} // تعيين اتجاه النص
    >
      {errors.general && (
        <div className="p-4 bg-error/10 border border-error/20 rounded-lg">
          <div className="flex items-center space-x-2">
            <Icon
              name="AlertCircle"
              size={16}
              className="text-error flex-shrink-0"
            />
            <p className="text-sm text-error">{errors.general}</p>
          </div>
        </div>
      )}

      <div className="space-y-4">
        <Input
          label={t("email_phone")}
          type="text"
          name="account"
          placeholder={t("emailPhonePlaceholder")}
          value={formData.account}
          onChange={handleInputChange}
          error={errors.account}
          required
          disabled={isLoading}
        />

        <div className="relative">
          <Input
            label={t("passwordLabel")}
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder={t("passwordPlaceholder")}
            value={formData.password}
            onChange={handleInputChange}
            error={errors.password}
            required
            disabled={isLoading}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className={`absolute ${
              i18n.language === "ar" ? "left-3" : "right-3"
            } top-9 text-text-secondary hover:text-text-primary transition-smooth`} // تغيير الموضع بناءً على اللغة
            disabled={isLoading}
          >
            <Icon name={showPassword ? "EyeOff" : "Eye"} size={18} />
          </button>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <button
          type="button"
          onClick={handleForgotPassword}
          className="text-sm text-primary hover:underline transition-smooth"
          disabled={isLoading}
        >
          {t("forgotPassword")}
        </button>
      </div>

      <Button
        type="submit"
        variant="default"
        size="lg"
        fullWidth
        loading={loading}
        className="rounded-[4px]"
        //   iconName="LogIn"
        //   iconPosition="left"
      >
        {t("signIn")}
      </Button>
    </form>
  );
};

export default LoginForm;
